import React, { useState } from "react";
import { Button, Text, Card, CardHeader, makeStyles } from "@fluentui/react-components";
import { Add16Regular, Person20Regular, BookContacts20Regular, ContactCard20Regular } from "@fluentui/react-icons";
import { ENTITY_CANDIDATE, ENTITY_RELATION, ENTITY_RELATION_CONTACT } from "../utils/Constants";
import { themeTokens } from "../utils/Theming";
import Icon from "../blocks/Icon";
import PageHeader from "../blocks/PageHeader";
import CandidateForm from "../features/candidate/form/CandidateForm";
import RelationForm from "../features/relation/form/RelationForm";
import RelationContactForm from "../features/relation-contact/form/RelationContactForm";
import Container from "../blocks/Container";

const useStyles = makeStyles({
  card: {
    marginBottom: themeTokens.spacingVerticalMNudge,
  },
  heading: {
    marginTop: 0,
  },
});

const EntityCreationPage = () => {
  const styles = useStyles();
  const [selectedEntity, setSelectedEntity] = useState(null);

  const handleCreateEntity = (entity) => {
    setSelectedEntity(entity);
  };

  const renderContent = () => {
    switch (selectedEntity) {
      case ENTITY_CANDIDATE:
        return <CandidateForm />;
      case ENTITY_RELATION:
        return <RelationForm />;
      case ENTITY_RELATION_CONTACT:
        return <RelationContactForm />;
      default:
        return null;
    }
  };

  const handleBack = () => {
    setSelectedEntity(null);
  };

  if (selectedEntity) {
    return (
      <div>
        <PageHeader onBack={handleBack} />
        <Container>{renderContent()}</Container>
      </div>
    );
  }

  return (
    <Container>
      <Text className={styles.heading} as="h2" size={400} weight="bold" block>
        Unknown e-mail address
      </Text>
      <Text as="p" block>
        We don't recognize this email, would you like to create a new candidate, relation, or relation contact in OTYS?
      </Text>

      <Card className={styles.card}>
        <CardHeader
          image={<Icon icon={<Person20Regular />} size="medium" />}
          header={<Text>New candidate</Text>}
          action={<Button onClick={() => handleCreateEntity(ENTITY_CANDIDATE)} icon={<Add16Regular />} />}
        />
      </Card>

      <Card className={styles.card}>
        <CardHeader
          image={<Icon icon={<BookContacts20Regular />} size="medium" />}
          header={<Text>New relation</Text>}
          action={<Button onClick={() => handleCreateEntity(ENTITY_RELATION)} icon={<Add16Regular />} />}
        />
      </Card>

      <Card className={styles.card}>
        <CardHeader
          image={<Icon icon={<ContactCard20Regular />} size="medium" />}
          header={<Text>New relation contact</Text>}
          action={<Button onClick={() => handleCreateEntity(ENTITY_RELATION_CONTACT)} icon={<Add16Regular />} />}
        />
      </Card>
    </Container>
  );
};

export default EntityCreationPage;